module.exports = __webpack_public_path__ + "img/image.61219453.svg";